
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import { getIndexConfig, getTableConfig, inputList } from './config'
import { usePagination } from '@/hooks/usePagination'
import { defineComponent, reactive, toRefs, onMounted, computed } from 'vue'
import { getList, dropdownOfEnterprise, platforms } from './api'
import { toResult } from '@/utils/toResult'
import { btnName } from '@/utils'
import CButtonGroup from '@/components/c-button-group'
import Edit from './edit.vue'
import DetailDialog from './detail.vue'

export default defineComponent({
  components: {
    CSearchList,
    CTable,
    Edit,
    DetailDialog,
    CButtonGroup,
  },
  setup() {
    const remoteData1 = reactive({
      options: [],
      isLoading: false,
      remoteMethod: (val) => {
        dropdownOfEnterprise({ value: val }).then((res) => {
          remoteData1.options = res.data.map((item) => {
            return {
              label: item.value,
              value: item.key,
            }
          })
        })
      },
    })
    const remoteData2 = reactive({
      options: [],
      isLoading: false,
    })
    const data = reactive({
      ...getIndexConfig(),
      isType: '',
      isedit: false,
      isdetail: false,
    })

    const inputListComputed = computed(() => inputList(remoteData1, remoteData2))

    const tableConfig = reactive({
      ...getTableConfig(),
    })

    const getListFn = async () => {
      const p = {
        ...data.queryForm,
        currPage: tableConfig.pagination.currentPage,
        pageSize: tableConfig.pagination.pageSize,
      }

      tableConfig.loading = true
      const [err, res] = await toResult(getList(p))
      tableConfig.loading = false
      if (err) return
      tableConfig.data = res.list || []
      tableConfig.pagination.total = res.total
    }

    // 查询
    const handleSearch = (params) => {
      tableConfig.pagination.currentPage = 1
      params && (data.queryForm = { ...params })
      getListFn()
    }

    // const onToggle = (name, row?) => {
    //   data[name] = !data[name]
    //   row && (data.rowData = row)
    // }

    const onToggle = (name) => {
      data[name] = !data[name]
    }

    // 重置
    const handleReset = (val) => {
      data.queryForm = val
    }

    const { pageCurrentChange, pageSizeChange } = usePagination(
      tableConfig.pagination,
      () => {
        getListFn()
      }
    )

    // 新增、修改 按钮操作
    const btnHandle = (type, row) => {
      data.rowData = Object.assign({}, row)
      // data.rowData = row
      switch (type) {
        case 'edit': {
          console.log(data.rowData)
          data.isType = 'edit'
          onToggle('isedit')
          break
        }
        case 'add': {
          data.rowData = {}
          data.isType = 'add'
          onToggle('isedit')
          break
        }
        case 'detail': {
          console.log(data.rowData)
          onToggle('isdetail')
          break
        }
      }
    }

    onMounted(() => {
      platforms({}).then((res) => {
        console.log('platforms res:', res)
        remoteData2.options = res.data.map((item) => {
          return {
            label: item,
            value: item,
          }
        })
        console.log('remoteData2.options:', remoteData2.options)
      })
      handleSearch({})
    })

    return {
      ...toRefs(data),
      inputListComputed,
      handleSearch,
      btnName,
      handleReset,
      tableConfig,
      pageCurrentChange,
      pageSizeChange,
      getListFn,
      onToggle,
      btnHandle,
    }
  },
})
